// extracted by mini-css-extract-plugin
module.exports = {"dropdown-menu":"DropdownMenu_dropdown-menu__v_V6u","expanded":"DropdownMenu_expanded__z8p0O","dropdown-menu__content":"DropdownMenu_dropdown-menu__content__58vaJ"};